import { useLayoutEffect, useRef } from 'react';
/**
 * useIsRendering - detects if the component is currently in render phase.
 * Returns `true` during render, `false` after commit.
 * Only works in development; in production always returns false.
 */ export function useIsRendering() {
    const isRendering = useRef(false);
    if (process.env.NODE_ENV !== 'production') {
        // Mark as rendering at the start of render
        isRendering.current = true;
        // After commit, reset it to false
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useLayoutEffect(()=>{
            isRendering.current = false;
        });
        // useLayout affect will not be called if react bails out, so call on next tick too
        Promise.resolve().then(()=>{
            isRendering.current = false;
        });
    } else {
        isRendering.current = false;
    }
    return isRendering;
}
